import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { AppOverviewFrameworks } from '../../../components/application-details/app-overview-frameworks'

function AngularAppOverviewFrameworks(props) {
  return <AppOverviewFrameworks {...props} />
}

export const reactAppOverviewFrameworks = createNgReactBridgeDirective(
  'reactAppOverviewFrameworks',
  [],
  AngularAppOverviewFrameworks,
  ['frameworks', 'isEnabled', 'isMerged', 'language', 'size']
)
